import React, { useState, useEffect } from 'react'

const ITConsulting = () => {
    const [activeService, setActiveService] = useState('it-strategy');

    useEffect(() => {
        // Add click event listeners to service tabs
        const tabs = document.querySelectorAll('.service-tab');
        const details = document.querySelectorAll('.service-detail');

        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                const service = tab.getAttribute('data-service');

                // Remove active class from all tabs and details
                tabs.forEach(t => t.classList.remove('active'));
                details.forEach(d => d.classList.remove('active'));

                // Add active class to clicked tab and corresponding detail
                tab.classList.add('active');
                document.getElementById(service).classList.add('active');

                setActiveService(service);
            });
        });
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <section className="breadcrumb-hero">
                <div className="breadcrumb-overlay"></div>
                <div className="breadcrumb-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                {/* <div className="breadcrumb-tagline">
                                    <span className="breadcrumb-line"></span>
                                    <span className="breadcrumb-text">STRATEGIC TECHNOLOGY GUIDANCE</span>
                                </div> */}
                                <h1 className="breadcrumb-title">
                                    IT <span className="breadcrumb-highlight">Consulting</span>
                                </h1>
                                <button className="breadcrumb-btn">
                                    <span>CONNECT NOW</span>
                                    <span className="breadcrumb-arrow">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcrumb-pattern"></div>
            </section>

            {/* IT Consulting Overview Section */}
            <section className="ai-driven-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="ai-driven-content">
                                <h2 className="ai-driven-title" style={{ textAlign: 'left' }}>
                                    <span className="text-gradient">Expert IT Consulting </span> for Digital Excellence
                                </h2>
                                <p className="ai-driven-description">
                                    Navigate the complex technology landscape with CLOUD MIND X's strategic IT consulting services. Our seasoned consultants bring decades of combined experience to help businesses align technology with business objectives, optimize IT operations, and drive digital transformation. We deliver actionable insights, proven methodologies, and hands-on expertise to transform your IT from a cost center into a competitive advantage.
                                </p>
                                <button className="ai-driven-btn">
                                    <span>TALK TO A CONSULTANT</span>
                                    <span className="ai-driven-arrow">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                </button>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="ai-driven-image-wrapper">
                                <img
                                    src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80"
                                    alt="IT Consulting Services"
                                    className="ai-driven-image"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* How We Help Section */}
            <section className="how-we-help-section">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="section-header text-center mb-5">
                                <span className="section-tagline">OUR CONSULTING EXPERTISE</span>
                                <h2 className="section-title" style={{ textAlign: 'center' }}>How We Help</h2>
                                <p className="text-muted lead m-0">
                                    With industry-certified consultants and proven track record across diverse sectors,<br />
                                    <span className="text-gradient">CLOUD MIND X</span> provides strategic IT consulting services that drive measurable<br />
                                    business outcomes, reduce costs, and accelerate innovation for organizations worldwide.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="row align-items-start">
                        {/* Left Side - Services Menu */}
                        <div className="col-lg-5">
                            <div className="services-menu">
                                <div className="service-tab active" data-service="it-strategy">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">IT Strategy & Roadmap</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="digital-transformation">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">Digital Transformation</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="enterprise-architecture">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">Enterprise Architecture</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="it-optimization">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">IT Infrastructure Optimization</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="technology-assessment">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">Technology Assessment</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="it-governance">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">IT Governance & Compliance</h3>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right Side - Service Details */}
                        <div className="col-lg-7">
                            <div className="service-details-container">
                                {/* IT Strategy */}
                                <div className="service-detail active" id="it-strategy">
                                    <h3 className="service-detail-title">IT Strategy & Roadmap</h3>
                                    <p className="service-detail-description">
                                        Develop comprehensive IT strategies aligned with your business goals. Our consultants assess current technology capabilities, identify gaps and opportunities, define target architectures, and create actionable roadmaps. We prioritize initiatives based on business value, feasibility, and ROI to ensure your technology investments deliver maximum impact.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Strategy Session</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* Digital Transformation */}
                                <div className="service-detail" id="digital-transformation">
                                    <h3 className="service-detail-title">Digital Transformation</h3>
                                    <p className="service-detail-description">
                                        Lead successful digital transformation initiatives that reimagine business processes and customer experiences. We guide organizations through technology adoption, process automation, data-driven decision-making, and cultural change. Our holistic approach ensures sustainable transformation that improves efficiency, agility, and competitive positioning.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Start Transformation Journey</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* Enterprise Architecture */}
                                <div className="service-detail" id="enterprise-architecture">
                                    <h3 className="service-detail-title">Enterprise Architecture</h3>
                                    <p className="service-detail-description">
                                        Design scalable, flexible enterprise architectures that support business growth and innovation. Our architects leverage frameworks like TOGAF and Zachman to create integrated architectures spanning business, data, application, and technology domains. We ensure alignment between IT capabilities and business requirements while reducing complexity.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Architecture Review</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* IT Optimization */}
                                <div className="service-detail" id="it-optimization">
                                    <h3 className="service-detail-title">IT Infrastructure Optimization</h3>
                                    <p className="service-detail-description">
                                        Optimize your IT infrastructure for performance, reliability, and cost-efficiency. We conduct comprehensive assessments of networks, servers, storage, and cloud resources to identify bottlenecks, security risks, and optimization opportunities. Our recommendations improve system performance, reduce operational costs, and enhance service delivery.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Infrastructure Audit</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* Technology Assessment */}
                                <div className="service-detail" id="technology-assessment">
                                    <h3 className="service-detail-title">Technology Assessment & Selection</h3>
                                    <p className="service-detail-description">
                                        Make informed technology decisions with comprehensive assessments and vendor evaluations. We analyze your requirements, research available solutions, conduct proof-of-concepts, and provide unbiased recommendations. Our expertise helps you select the right technologies, platforms, and vendors that align with your needs and budget.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Technology Assessment</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* IT Governance */}
                                <div className="service-detail" id="it-governance">
                                    <h3 className="service-detail-title">IT Governance & Compliance</h3>
                                    <p className="service-detail-description">
                                        Establish robust IT governance frameworks that ensure accountability, risk management, and regulatory compliance. We implement ITIL, COBIT, and ISO standards, define policies and procedures, and create governance structures. Our approach balances control with agility, enabling effective IT management while supporting business innovation.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Governance Assessment</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* IT Consulting Capabilities Section */}
            <section className="ai-capabilities-section">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="section-header text-center mb-5">
                                <span className="section-tagline-white">AREAS OF EXPERTISE</span>
                                <h2 className="section-title-dark">IT Consulting Domains & Specializations</h2>
                                <p className="section-description-dark">
                                    CLOUD MIND X brings deep expertise across diverse IT domains and industry verticals. Our consulting practice covers <strong>strategic planning, implementation, and optimization</strong> across healthcare, financial services, retail, manufacturing, education, logistics, and technology sectors, delivering tailored solutions that address unique business challenges.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        {/* Business Process Optimization */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="8" y="12" width="32" height="24" rx="3" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M16 20H32M16 24H28M16 28H24" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <circle cx="34" cy="32" r="6" fill="#4187f7" opacity="0.2" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M32 32L34 34L36 30" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Business Process Optimization</h4>
                                <p className="capability-description">
                                    Streamline operations and eliminate inefficiencies through comprehensive process analysis and redesign. We identify automation opportunities, implement workflow improvements, and leverage technology to reduce cycle times, minimize errors, and enhance productivity. Our process optimization delivers measurable cost savings and operational excellence.
                                </p>
                            </div>
                        </div>

                        {/* Change Management */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="24" cy="24" r="14" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M24 14V24L30 30" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M18 8C20 6 22 5 24 5C32 5 38 11 38 19" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M35 16L38 19L41 16" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Change Management</h4>
                                <p className="capability-description">
                                    Successfully navigate organizational change with structured change management methodologies. We develop communication strategies, training programs, and stakeholder engagement plans that ensure smooth technology adoption. Our approach minimizes resistance, accelerates user adoption, and maximizes the value of IT investments.
                                </p>
                            </div>
                        </div>

                        {/* Data & Analytics Strategy */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="8" y="28" width="6" height="12" rx="1" stroke="#4187f7" strokeWidth="2" />
                                        <rect x="17" y="20" width="6" height="20" rx="1" stroke="#4187f7" strokeWidth="2" />
                                        <rect x="26" y="14" width="6" height="26" rx="1" stroke="#4187f7" strokeWidth="2" />
                                        <rect x="35" y="22" width="6" height="18" rx="1" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M8 18L14 12L20 16L26 8L32 14L38 10" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Data & Analytics Strategy</h4>
                                <p className="capability-description">
                                    Unlock the power of data with comprehensive analytics strategies and data governance frameworks. We design data architectures, implement business intelligence solutions, and establish data quality standards. Our approach transforms raw data into actionable insights that drive informed decision-making and competitive advantage.
                                </p>
                            </div>
                        </div>

                        {/* Application Modernization */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="10" y="10" width="28" height="28" rx="4" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M18 22L22 26L30 18" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <circle cx="35" cy="13" r="5" fill="#4187f7" opacity="0.2" />
                                        <path d="M35 11V15M33 13H37" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Application Modernization</h4>
                                <p className="capability-description">
                                    Revitalize legacy applications to meet modern business demands. We assess application portfolios, recommend modernization approaches (refactor, replatform, rebuild), and execute transformation initiatives. Our modernization strategies improve performance, reduce maintenance costs, enhance security, and enable cloud-native capabilities.
                                </p>
                            </div>
                        </div>

                        {/* Vendor Management */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="24" cy="18" r="6" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M12 38C12 32 16 28 24 28C32 28 36 32 36 38" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <circle cx="14" cy="16" r="4" stroke="#4187f7" strokeWidth="2" />
                                        <circle cx="34" cy="16" r="4" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M8 34C8 30 10 28 14 28M40 34C40 30 38 28 34 28" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Vendor Management</h4>
                                <p className="capability-description">
                                    Optimize vendor relationships and technology partnerships for better outcomes and cost efficiency. We assist with vendor selection, contract negotiation, SLA management, and performance evaluation. Our vendor management practices ensure accountability, value delivery, and alignment with business objectives.
                                </p>
                            </div>
                        </div>

                        {/* IT Service Management */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="8" y="12" width="32" height="24" rx="2" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M8 18H40" stroke="#4187f7" strokeWidth="2" />
                                        <circle cx="13" cy="15" r="1" fill="#4187f7" />
                                        <circle cx="17" cy="15" r="1" fill="#4187f7" />
                                        <circle cx="21" cy="15" r="1" fill="#4187f7" />
                                        <path d="M16 24H32M16 28H28" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">IT Service Management</h4>
                                <p className="capability-description">
                                    Implement ITIL-based service management frameworks that improve IT service delivery and support. We design service catalogs, establish incident and problem management processes, implement change control procedures, and create service level agreements. Our ITSM solutions enhance user satisfaction and operational efficiency.
                                </p>
                            </div>
                        </div>

                        {/* Technology Risk Management */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 8L36 14V22C36 29 30 35 24 40C18 35 12 29 12 22V14L24 8Z" stroke="#4187f7" strokeWidth="2" strokeLinejoin="round" />
                                        <circle cx="24" cy="23" r="3" fill="#4187f7" />
                                        <path d="M24 27V30" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Technology Risk Management</h4>
                                <p className="capability-description">
                                    Identify, assess, and mitigate technology-related risks that threaten business operations. We conduct comprehensive risk assessments, develop risk mitigation strategies, and implement controls for security, compliance, and business continuity. Our risk management approach protects assets while enabling calculated innovation.
                                </p>
                            </div>
                        </div>

                        {/* IT Budget & Cost Management */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="24" cy="24" r="14" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M24 16V24L30 27" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M20 10C18 12 17 14 17 16M28 10C30 12 31 14 31 16" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <rect x="22" y="8" width="4" height="3" rx="1" fill="#4187f7" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">IT Budget & Cost Management</h4>
                                <p className="capability-description">
                                    Optimize IT spending and maximize return on technology investments. We develop IT budgets, implement cost allocation models, identify cost-saving opportunities, and establish financial governance. Our approach balances cost control with strategic investments, ensuring IT resources are allocated effectively to support business priorities.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ITConsulting
